import type { TrPageConfigInterface } from '@core/utils/TrPageConfig.interface'
import { useLoadingStore } from '@/stores/loading'
import { useSlugHelper } from '@/router/useSlugHelper'

const Names = {
  fr: 'sondage',
  en: 'survey'
}

const Config: TrPageConfigInterface = {
  name: Names.fr,
  path: `/${Names.fr}`,
  alias: `/${Names.en}`,
  meta: {
    title: {
      fr: 'Sondage',
      en: 'Survey'
    },
    description: {
      fr: 'Faits saillants - Sondage d’opinion et de perception des Québecois',
      en: 'Highlights - Opinion and Perception Survey of Quebecers'
    }
  },
  component: () => import('@page/survey/Survey.vue'),
  beforeEnter: async (to, from, next) => {
    const loadingStore = useLoadingStore()
    loadingStore.toggleLoading({ set: true })
    next(await useSlugHelper().checkPageSlug(to.path, Names))
  }
}

export { Config }
